import React, { useEffect } from 'react';
import { Form, Button, Space, Alert } from 'antd';
import { SaveOutlined, InfoCircleOutlined } from '@ant-design/icons';
import type { KrybotAgent } from '../../../types/krybot';
import { JsonSchemaEditor } from './JsonSchemaEditor';
import styles from './AgentManagement.module.css';

interface AgentInputTabProps {
  agent: KrybotAgent | null;
  agentData: Partial<KrybotAgent>;
  isCreating: boolean;
  onDataChange: (updates: Partial<KrybotAgent>) => void;
  onSave: () => void;
  loading: boolean;
}

export const AgentInputTab: React.FC<AgentInputTabProps> = ({
  agent,
  agentData,
  isCreating,
  onDataChange,
  onSave,
  loading,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      input_schema: agentData.input_schema || {},
    });
  }, [agentData.input_schema, form]);

  const handleChange = (value: Record<string, unknown> | null) => {
    onDataChange({ input_schema: value || {} });
  };

  const validateJson = (_: unknown, value: Record<string, unknown> | null) => {
    if (!value) {
      return Promise.resolve();
    }
    return Promise.resolve();
  };

  return (
    <div className="agent-input-tab">
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0 }}>Input Schema</h3>
        <Button
          type="primary"
          icon={<SaveOutlined />}
          onClick={onSave}
          loading={loading}
        >
          Save Changes
        </Button>
      </div>
      <Alert
        message="Input Schema"
        description="JSON Schema that defines the structure of input data the agent expects. This may be auto-populated from the selected template."
        type="info"
        icon={<InfoCircleOutlined />}
        style={{ marginBottom: 16 }}
      />
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          input_schema: agentData.input_schema || {},
        }}
      >
        <Form.Item
          name="input_schema"
          rules={[{ validator: validateJson }]}
          help="JSON Schema that defines the structure of input data the agent expects. May be auto-populated from template."
        >
          <JsonSchemaEditor
            fieldType="input_schema"
            agentType={agentData.agent_type}
            disabled={loading}
            value={agentData.input_schema}
            onChange={handleChange}
            placeholder='{"type": "object", "properties": {...}}'
          />
        </Form.Item>
      </Form>
    </div>
  );
};

